<template>
  <v-snackbar
    v-model="show"
    :color="type"
    :bottom="y === 'bottom'"
    :timeout="2000"
    :top="y === 'top' "
  >
    <p>{{text }}</p>
  </v-snackbar>
</template>

<script>
export default {
  props: ["show","type","text"],
  data () {
    return {
     
    }
  },
  
}
</script>
